// extracted by mini-css-extract-plugin
module.exports = {"copies":"CopiesIcon__copies___26vym"};